module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><g><rect stroke-width=\"0\" width=\"100\" height=\"100\"></rect></g></svg>"